<template>
  <v-dialog v-model="dialog" persistent max-width="900">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <slot></slot>
      </div>
    </template>
    <v-card class="pa-4">
      <v-card-actions class="justify-center">
        <div style="width: 95%">
          <div class="text-h6 grey82 pb-8 popup-title">
            <translate>Information</translate>
          </div>
          <AutoForm :layout="layout" :model="entity" ref="form" />
          <div class="d-flex mt-4">
            <v-btn
              color="#E0E0E0"
              @click="action(false)"
              height="40"
              class="btn-cancel"
            >
              <translate>Cancel</translate>
            </v-btn>

            <v-btn
              color="primary"
              @click="action(true)"
              class="ml-5"
              height="40"
            >
              <translate>Save</translate>
            </v-btn>
          </div>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import CountryFlag from "@/components/CountryFlag";
import EditInfoGolfClubForm from "@/forms/EditInfoGolfClubForm";
import AutoForm from "@/components/Forms/AutoForm";
export default {
  props: {
    value: {},
    course: {}
  },
  components: {
    CountryFlag,
    EditInfoGolfClubForm,
    AutoForm
  },
  data() {
    return {
      dialog: false,
      fullname: null,
      phone: null,
      entity: null,
    };
  },
  computed: {
    layout() {
      return EditInfoGolfClubForm.layout(
        this.entity,
      );
    },
    user() {
      return this.$store.state.auth.user;
    },

    courseDetail() {
      return this.$store.state.golfcourse.courseDetail;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dialog = val;
      }
    },
    courseDetail: {
      immediate: true,
      handler(value) {
        if (value && value.id) {
          this.resetForm();
          this.entity = JSON.parse(JSON.stringify(value));
        } else {
          this.resetForm();
        }
      }
    },
  },
  mounted() {
    this.fullname = this.user.firstName + " " + this.user.lastName;
    this.phone = this.user.phone;
  },
  methods: {
    resetForm() {
      this.entity = Object.assign({}, EditInfoGolfClubForm.defaultEntity);
    },
    async changeState(val) {
      if (val) {
        await this.setCityList(val.id);
      } else {
        this.cityList = [];
      }
    },
    isURL(str) {
      let url;
      if (str === "") return true;
      try {
        url = new URL(str);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    },
    async action(temp) {
      if (temp == true) {
        if (this.$refs.form.validate()) {
          const data = {
            id: this.entity.id,
            phone: this.entity.phone,
            facebookUrl: this.entity.facebookUrl,
            youtubeUrl: this.entity.youtubeUrl,
            twitterUrl: this.entity.twitterUrl,
            instagramUrl: this.entity.instagramUrl,
            tripadvisorUrl: this.entity.tripadvisorUrl,
            website: this.entity.website
          }
          const response = await this.$store.dispatch("editInfoGolfClub", data);
          if (response.error) {
            this.$toast.alert(result.error.message);
          } else {
            this.$toast.success(`Update success`);
            await this.$store.dispatch('getDetailCourse', response.slug)
          }
          this.dialog = false;
        }
      } else {
        this.dialog = false;
        this.$emit("action", temp);
      }
    }
  }
};
</script>
